<template>
  <div>
    <Table border ref="selection" :loading="loading" :columns="columns" :data="data" width="500">
      <template slot-scope="{ row, index }" slot="action">
        <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editBtn(row, index)"></Icon>
      </template>
    </Table>

    <div v-show="showKPI" style="margin: 30px 0">
      <FormTitle titleText="KPI"/>
      <Table border :loading="loading" :columns="columns1" :data="data1">
        <template slot-scope="{ row, index }" slot="action1">
          <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editKPI(row, index)"></Icon>
        </template>
      </Table>
      <div v-show="showKPIDetail" style="margin-top:30px">
        <Table border :loading="loading" :columns="columns2" :data="data2">
        </Table>
      </div>
    </div>

    <div v-show="showBSC" style="margin: 30px 0">
      <FormTitle titleText="BSC"/>
      <Table border :loading="loading" :columns="columns3" :data="data3"  width="500">
        <template slot-scope="{ row, index }" slot="action3">
          <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editBSC(row, index)"></Icon>
        </template>
      </Table>
      <div v-show="showBSCDetail" style="margin: 30px 0">
        <Table border :loading="loading" :columns="columns4" :data="data4">
        </Table>
      </div>
    </div>

    <div v-show="showPlan" style="margin: 30px 0">
      <FormTitle titleText="个人发展计划"/>
      <div v-show="showPlan" style="margin: 30px 0">
        <Table border :loading="loading" :columns="columns5" :data="data5">
          <template slot-scope="{ row, index }" slot="action3">
            <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editPlan(row, index)"></Icon>
          </template>
        </Table>
      </div>
    </div>
    <div v-show="showWork" style="margin: 30px 0">
      <FormTitle titleText="重点工作"/>
      <Table border :loading="loading" :columns="columns6" :data="data6">
        <template slot-scope="{ row, index }" slot="action3">
          <Icon type="ios-create" style="font-size: 30px" color="#8CD29B"  @click="editWork(row, index)"></Icon>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      columns: [
        {
          title: "模板类型",
          key: "mubanType",
          align: "center",
        },
        {
          title: "查看",
          slot:"action",
          align: "center",
          width: "200",
        },
      ],
      data: [
        {
          mubanType:'KPI',
        },
        {
          mubanType:'BSC',
        },
        {
          mubanType:'个人发展计划',
        },
        {
          mubanType:'重点工作',
        },
      ],
      columns1: [
        {
          title: "指标项",
          key: "indicatorItem",
          align: "center",
          minWidth: 120,
        },
        {
          title: "内容概述",
          key: "contentOverview",
          align: "center",
          minWidth: 330,
        },
        {
          title: "权重（%）",
          key: "weights",
          align: "center",
          minWidth: 120,
        },
        {
          title: "评分方法",
          key: "scoringMethod",
          align: "center",
          minWidth: 120,
        },
        {
          title: "数据来源",
          key: "dataSources",
          align: "center",
          minWidth: 120,
        },
        {
          title: "目标分解",
          slot:"action1",
          align: "center",
          minWidth: 120,
        },
        {
          title: "完成度",
          minWidth: 120,
        },
        {
          title: "自评",
          minWidth: 120,
        },
        {
          title: "他评",
          minWidth: 120,
        },
        {
          title: "得分",
          minWidth: 120,
        },
      ],
      data1: [
        {
          indicatorItem:'企业税务策略',
          contentOverview:'节约税收',
          weights:'20',
          scoringMethod:'',
          dataSources:'财务部',
        },
        {
          indicatorItem:'审计和法务方面',
          contentOverview:'所有审计和法律事务方面的问题都得到了分析',
          weights:'30',
          scoringMethod:'',
          dataSources:'',
        },
      ],
      columns2: [
        {
          title: "指标项",
          key: "indicatorItem",
          align: "center",
          minWidth: 120,
        },
        {
          title: "内容概述",
          key: "contentOverview",
          align: "center",
          minWidth: 120,
        },
        {
          title: "目标分解",
          key: "targetDecomposition",
          align: "center",
          minWidth: 120,
        },
        {
          title: "达成效果",
          key: "achieveEffect",
          align: "center",
          minWidth: 120,
        },
        // {
        //   title: "操作",
        //   slot:"action2",
        //   align: "center",
        //   width: "200",
        // },
      ],
      data2: [
        {
          indicatorItem:'企业税务策略',
          contentOverview:'节约税收',
          targetDecomposition:'提供的企业税务策略',
          achieveEffect:'策略成本低，效率大',
        },
        {
          indicatorItem:'企业税务策略',
          contentOverview:'节约税收',
          targetDecomposition:'',
          achieveEffect:'',
        },
      ],
      columns3: [
        {
          title: "指标维度",
          key: "metricDimension",
          align: "center",
          minWidth: 120,
        },
        {
          title: "查看",
          slot:"action3",
          align: "center",
          minWidth: 200,
        },
      ],
      data3: [
        {
          metricDimension:'财务维度',
        },
        {
          metricDimension:'客户角度',
        },
        {
          metricDimension:'内部运营',
        },
        {
          metricDimension:'学习成长',
        },
      ],
      columns4: [
        {
          title: "指标维度",
          key: "metricDimension",
          align: "center",
          minWidth: 120,
        },
        {
          title: "衡量要素",
          key: "measureFactor",
          align: "center",
          minWidth: 120,
        },
        {
          title: "指标名称",
          key: "indicatorName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "指标定义",
          key: "indicatorDefinition",
          align: "center",
          minWidth: 120,
        },
        {
          title: "设立目的",
          key: "purposeOfEstablishment",
          align: "center",
          minWidth: 120,
        },
        {
          title: "数据收集",
          key:"dataCollection",
          align: "center",
          minWidth: 120,
        },
        {
          title: "备注",
          key:"Remark",
          align: "center",
          minWidth: 120,
        },
        {
          title: "完成度",
          minWidth: 120,
        },
        {
          title: "自评",
          minWidth: 120,
        },
        {
          title: "他评",
         minWidth: 120,
        },
        {
          title: "得分",
          minWidth: 120,
        },
      ],
      data4: [
        {
          metricDimension:'财务维度',
          measureFactor:'成本控制',
          indicatorName:'管理费用降低',
          indicatorDefinition:'计划期内，人力资源管理费用支出占销售收入的比率降低',
          purposeOfEstablishment:'促使人事行政系统通过预算管理有效提高管理费用支出和降低管理费用率',
          dataCollection:'财务部',
          Remark:'',
        },
      ],
      columns5: [
        {
          title: "待提高或发展的能力/经验",
          key: "metricDimension",
          align: "center",
          minWidth: 260,
        },
        {
          title: "实施活动及衡量标准（活动要具体、个性化、可衡量）",
          key: "measureFactor",
          align: "center",
          minWidth: 260,
        },
        {
          title: "计划完成时间（计划要可执行）",
          key: "indicatorName",
          align: "center",
          minWidth: 260,
        },
        {
          title: "完成度（%）",
          key: "indicatorDefinition",
          align: "center",
          minWidth: 260,
        },
        {
          title: "描述",
          key: "purposeOfEstablishment",
          align: "center",
          minWidth: 260,
        },
        {
          title: "自评",
          key:"dataCollection",
          align: "center",
          minWidth: 120,
        },
        {
          title: "备注",
          key:"Remark",
          align: "center",
          minWidth: 120,
        },
      ],
      data5: [
        {
          metricDimension:'ER&非物质激励',
          measureFactor:'通过实施相关的活动，整理Lessons Learned,形成远景AESC年度HR活动日历',
          indicatorName:'2021/12/31',
          indicatorDefinition:'50',
          purposeOfEstablishment:'未完成HR年度活动日历',
          dataCollection:'80',
          Remark:'',
        },
      ],
      columns6: [
        {
          title: "解决的挑战及目标描述",
          key: "metricDimension",
          align: "center",
          minWidth: 260,
        },
        {
          title: "完成的标准及交附件",
          key: "measureFactor",
          align: "center",
          minWidth: 260,
        },
        {
          title: "权重（%）",
          key: "indicatorName",
          align: "center",
          minWidth: 260,
        },
        {
          title: "关键举措",
          key: "indicatorDefinition",
          align: "center",
          minWidth: 260,
        },
        // 后边年初不显示
        {
          title: "完成度（%）",
          key: "purposeOfEstablishment",
          align: "center",
          minWidth: 260,
        },
        {
          title: "描述",
          key:"dataCollection",
          align: "center",
          minWidth: 120,
        },
        {
          title: "自评",
          minWidth: 120,
        },
        {
          title: "备注",
          key:"Remark",
          align: "center",
          minWidth: 120,
        },
      ],
      data6: [
        {
          metricDimension:'员工关系和非物质激励',
          measureFactor:'1.中秋、圣诞、春节几大HR负责的节日2.员工生日会/体育俱乐部通过专题活动着地员工关系和非物3.非物质激励(例如: Good job card+Thank you card)4.主题活动(如高管面对面)5.员工落户激励政策',
          indicatorName:'10',
          indicatorDefinition:'通过专题活动落地员工关系和非物质激励的举措',
          purposeOfEstablishment:'2员工生日会/体育俱乐部__完成',
          Remark:'',
        },
      ],
      loading: false,
      showKPI: false,
      showBSC: false,
      showKPIDetail: false,
      showBSCDetail: false,
      showPlan: false,
      showWork: false,
    };
  },
  methods: {
    editBtn(row, index) {
      if (row.mubanType == "KPI") {
        this.showKPI = true;
        this.showBSC = false;
        this.showBSCDetail = false;
        this.showPlan = false;
        this.showWork = false;
      } else if (row.mubanType == "BSC") {
        this.showBSC = true;
        this.showKPI = false;
        this.showKPIDetail = false;
        this.showPlan = false;
        this.showWork = false;
      } else if (row.mubanType == "个人发展计划") {
        this.showPlan = true;
        this.showKPI = false;
        this.showKPIDetail = false;
        this.showBSC = false;
        this.showBSCDetail = false;
        this.showWork = false;

      } else if (row.mubanType == "重点工作") {
        this.showWork = true;
        this.showKPI = false;
        this.showKPIDetail = false;
        this.showBSC = false;
        this.showBSCDetail = false;
        this.showPlan = false;
      }
    },
    editKPI(row,index) {
      this.showKPIDetail = true
    },
    editBSC(row, index){
      this.showBSCDetail = true
    },
    editPlan(row, index){
      this.showBSCDetail = true
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/performanceAndScoreRule.vue